// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__cOQNQ","footer-links":"Footer_footer-links__OTMr1","loading-value":"Footer_loading-value__N1gM1"};